import { ActivitiesAggrigatorModel } from "@shared/model/activities-aggrigator-model";
import { ActivityVerbEnum } from "@shared/model/enum/activity-verb-enum";
import { ObjectTypeEnum } from "@shared/model/enum/object-type-enum";

export function getIconUrl(
    imageUrl: string,
    activity: ActivitiesAggrigatorModel
): string {

    /**
     * Returns the proper icon URL for each activity type
     * (book cover, post image, user avatar, etc.)
     */

    const verb = activity?.verb;
    const objectType = activity?.inDirectObject?.objectType ?? ObjectTypeEnum.Post;
    const objectId = activity?.inDirectObject?.objectId ?? '';
    const bookId = activity?.object?.data?.book?.id ?? '';
    const actorId = activity?.actor?.id ?? '';


    switch (verb) {
        //  Comment-related URLs
        case ActivityVerbEnum.Commented:
            if (activity?.carried?.data?.objectType === ObjectTypeEnum.Message) {
                return `${imageUrl}/books/${bookId}.jpg`;
            }
            switch (objectType) {
                case ObjectTypeEnum.Review:
                case ObjectTypeEnum.Quote:
                case ObjectTypeEnum.Progress:
                    return `${imageUrl}/books/${activity?.object?.objectId}.jpg`;

                case ObjectTypeEnum.Post:
                    return `${imageUrl}/posts/${objectId}.jpg`;

                case ObjectTypeEnum.Booklist:
                    {
                        if (activity?.inDirectObject?.data === null) return '';
                        return `${imageUrl}/avatars/${actorId}.jpg`;
                    };

                case ObjectTypeEnum.badge:
                case ObjectTypeEnum.UserChallenge:
                case ObjectTypeEnum.Club:
                case ObjectTypeEnum.UserReportPublished:
                    return `${imageUrl}/avatars/${actorId}.jpg`;

                default:
                    return `${imageUrl}/default.jpg`;
            }

        // Like-related URLs
        case ActivityVerbEnum.Liked:
            switch (objectType) {
                case ObjectTypeEnum.Review:
                case ObjectTypeEnum.Quote:
                case ObjectTypeEnum.Progress:
                    return `${imageUrl}/books/${activity?.object?.objectId}.jpg`;

                case ObjectTypeEnum.Post:
                    return `${imageUrl}/posts/${objectId}.jpg`;

                case ObjectTypeEnum.Booklist:
                    {
                        if (activity?.inDirectObject?.data === null) return '';
                        return `${imageUrl}/avatars/${actorId}.jpg`;
                    };

                case ObjectTypeEnum.badge:
                case ObjectTypeEnum.UserChallenge:
                case ObjectTypeEnum.Club:
                case ObjectTypeEnum.UserReportPublished:
                    return `${imageUrl}/avatars/${actorId}.jpg`;

                default:
                    return '';
            }

        case ActivityVerbEnum.Followed:
        case ActivityVerbEnum.Joined:
        case ActivityVerbEnum.FollowRequested:
            return `${imageUrl}/avatars/${actorId}.jpg`;

        case ActivityVerbEnum.Reviewed:
        case ActivityVerbEnum.Quoted:
            return `${imageUrl}/books/${activity?.object?.objectId}.jpg`;

        case ActivityVerbEnum.Posted:
            return `${imageUrl}/posts/${objectId}.jpg`;


        case ActivityVerbEnum.ClubInvited:
        case ActivityVerbEnum.ClubJoinRequested:
        case ActivityVerbEnum.Coursed:
        case ActivityVerbEnum.CourseEnded:
        case ActivityVerbEnum.Polled:
        case ActivityVerbEnum.PollClosed:
        case ActivityVerbEnum.ClubJoinRequestAccepted:
            return `${imageUrl}/clubs/${objectId}.jpg`;


        case ActivityVerbEnum.Meetinged:
            if (activity?.inDirectObject === null) return ''
            return `${imageUrl}/clubs/${objectId}.jpg`;


        case ActivityVerbEnum.ChallengeObtained:
        case ActivityVerbEnum.Reminder:
            return `${imageUrl}/challenges/${activity?.inDirectObject?.data?.challenge?.id}.svg`;


        case ActivityVerbEnum.AchievementObtained:
            return `${imageUrl}/achievements/${activity?.inDirectObject?.data?.assigned?.objectId}.svg`;


        default:
            return '';
    }
}
